module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Glass-martini-a0a11e3fd87819a47f28a4da3a9c32ed.svg";